module.exports = __webpack_public_path__ + "static/media/skeleton.14868e5b.jpg";